import React from 'react';
import { FormBuilder } from 'commons-ui';
import useEdit from './useEdit';

import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG } from '../../helper';

const EditPermissions: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useEdit();
	return (
		<FormBuilder
			data={data}
			mode='edit'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			setShowLoader={setShowLoader}
			fieldConfig={FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
		/>
	);
};

export default EditPermissions;
